/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type cityPage_city$ref: FragmentReference;
export type cityPage_city = {|
  +slug: string,
  +name: string,
  +caption: ?string,
  +color: ?string,
  +picture: ?string,
  +headerPicture: ?string,
  +seo: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +social: ?{|
    +twitter: ?$ReadOnlyArray<?{|
      +type: ?string,
      +title: ?string,
      +image: ?string,
      +handle: ?string,
      +description: ?string,
    |}>,
    +generic: ?$ReadOnlyArray<?{|
      +title: ?string,
      +image: ?string,
      +description: ?string,
    |}>,
  |},
  +articles: $ReadOnlyArray<{|
    +slug: ?string,
    +title: ?string,
    +readingTime: ?number,
    +picture: ?string,
    +caption: ?string,
    +city: ?{|
      +slug: string,
      +color: ?string,
      +name: string,
    |},
    +author: ?{|
      +firstname: ?string,
      +lastname: ?string,
    |},
    +publishedAt: ?string,
  |}>,
  +products: $ReadOnlyArray<{|
    +slug: string,
    +name: string,
    +summary: string,
    +picture: string,
    +preview: $ReadOnlyArray<string>,
  |}>,
  +events: $ReadOnlyArray<{|
    +slug: string
  |}>,
  +map: {|
    +defaultCenter: ?{|
      +latitude: ?number,
      +longitude: ?number,
    |},
    +placeCategories: ?$ReadOnlyArray<?{|
      +name: string,
      +markerIcon: ?string,
      +places: ?$ReadOnlyArray<?{|
        +name: string,
        +picture: string,
        +placeId: string,
        +location: {|
          +latitude: ?number,
          +longitude: ?number,
        |},
      |}>,
    |}>,
  |},
  +related: $ReadOnlyArray<{|
    +slug: string,
    +name: string,
    +caption: ?string,
  |}>,
  +$refType: cityPage_city$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "latitude",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "longitude",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "cityPage_city",
  "type": "City",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    v2,
    v3,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerPicture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seo",
      "storageKey": null,
      "args": null,
      "concreteType": "SEO",
      "plural": false,
      "selections": [
        v5,
        v6
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "social",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMedia",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "twitter",
          "storageKey": null,
          "args": null,
          "concreteType": "TwtrSlices",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            v5,
            v7,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "handle",
              "args": null,
              "storageKey": null
            },
            v6
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "generic",
          "storageKey": null,
          "args": null,
          "concreteType": "GenSocialSlices",
          "plural": true,
          "selections": [
            v5,
            v7,
            v6
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "articles",
      "storageKey": "articles(first:1000)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000,
          "type": "Int"
        }
      ],
      "concreteType": "Article",
      "plural": true,
      "selections": [
        v0,
        v5,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "readingTime",
          "args": null,
          "storageKey": null
        },
        v4,
        v2,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "city",
          "storageKey": null,
          "args": null,
          "concreteType": "City",
          "plural": false,
          "selections": [
            v0,
            v3,
            v1
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "author",
          "storageKey": null,
          "args": null,
          "concreteType": "Author",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstname",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "lastname",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "publishedAt",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "products",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        v0,
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "summary",
          "args": null,
          "storageKey": null
        },
        v4,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "preview",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "events",
      "storageKey": null,
      "args": null,
      "concreteType": "Event",
      "plural": true,
      "selections": [
        v0
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "map",
      "storageKey": null,
      "args": null,
      "concreteType": "CityMap",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "defaultCenter",
          "storageKey": null,
          "args": null,
          "concreteType": "GeoPoint",
          "plural": false,
          "selections": v8
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "placeCategories",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaceCategory",
          "plural": true,
          "selections": [
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "markerIcon",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "places",
              "storageKey": null,
              "args": null,
              "concreteType": "Place",
              "plural": true,
              "selections": [
                v1,
                v4,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "placeId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "location",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "GeoPoint",
                  "plural": false,
                  "selections": v8
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "related",
      "storageKey": null,
      "args": null,
      "concreteType": "City",
      "plural": true,
      "selections": [
        v0,
        v1,
        v2
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b1ce0a08965e95206ebb30fa16f4164a';
module.exports = node;
